import React from 'react';

import { AuthSignupContext } from 'src/providers/AuthSignupProvider';

export const useAuthSignup = () => {
  return React.use(AuthSignupContext);
};
